<section class="news-section p-mt-2 p-mb-4 p-pl-3 p-pr-3" [id]="uid">
  <div class="p-col-12" [ngClass]="komunikat.typ">
    <div class="p-col-12 p-d-flex p-flex-row p-align-center komunikaty-tytul">
      <i *ngIf="komunikat?.ikona" [ngClass]="komunikat.ikona"></i>
      <h2 class="tytul-text h2" [innerHTML]="komunikat.tytul"></h2>
    </div>
    <div *ngIf="komunikat?.podtytul" [ngClass]="{paddingLeft: komunikat?.ikona}" class="p-col-12 podtytul-text p-pt-0 p-pb-0" [innerHTML]="komunikat.podtytul"></div>
    <div class="p-col-12 p-flex-column p-d-flex ">
      <div *ngIf="isSafeHtml" class="komunikat-tresc" [ngClass]="{textVisibility: showLongCommunicate && komunikat.tresc.length > 500}" [innerHTML]="komunikat.tresc | safeHtml"></div>
      <div *ngIf="!isSafeHtml" class="komunikat-tresc" [ngClass]="{textVisibility: showLongCommunicate && komunikat.tresc.length > 500}" [innerHTML]="komunikat.tresc"></div>
      <ds-button styleClass="right btn-style p-mt-2" icon="pi pi-arrow-right" iconPos="right" *ngIf="komunikat.tresc.length > 500" severity="link" [label]="showLongCommunicate ? 'Pokaż więcej' : 'Ukryj'" (click)="showHideCommunicate()"></ds-button>
    </div>
  </div>
</section>

